const resource = 'emailTemplates';

export default ($axios) => ({
	getEmailTemplates() {
		return $axios.get(`/${resource}`);
	}
})